import { createAction, props } from '@ngrx/store';
import { DsrActivity, LinehaulSchedule, Note } from '@xpo-ltl/sdk-linehaulpayform';
import { ActionPatchData } from '../app.state';

interface ActivityActionProps {
  actvtySequenceNbr?: string;
  activity?: DsrActivity;
  schSequenceNbr?: string;
}

export interface DsrActivityCommentAction {
  comment: Note;
}

export interface DsrActivityScheduleAction {
  schedule?: LinehaulSchedule;
  schSequenceNbr?: string;
  patchData?: ActionPatchData;
}

export const addActivityAction = createAction('[Activities] Add activity', props<ActivityActionProps>());

export const updateActivityAction = createAction('[Activities] Update activity', props<ActivityActionProps>());

export const deleteActivityAction = createAction('[Activities] Delete activity', props<ActivityActionProps>());

export const moveActivityAction = createAction('[Activities] Move activity', props<ActivityActionProps>());
